"use strict";

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.object.assign");

var _slicedToArray = require("/Users/sammarks/Code/website/node_modules/@babel/runtime/helpers/slicedToArray");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.index-of");

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PageHead = exports.usePageHeadPrefix = exports.PageHeadProvider = exports.PageHeadContext = void 0;

var react_1 = __importDefault(require("react"));

var react_helmet_1 = require("react-helmet");

exports.PageHeadContext = react_1["default"].createContext(undefined);

function PageHeadProvider(_a) {
  var children = _a.children,
      rest = __rest(_a, ["children"]);

  var _react_1$default$useS = react_1["default"].useState(undefined),
      _react_1$default$useS2 = _slicedToArray(_react_1$default$useS, 2),
      titlePrefix = _react_1$default$useS2[0],
      setTitlePrefix = _react_1$default$useS2[1];

  return react_1["default"].createElement(exports.PageHeadContext.Provider, {
    value: Object.assign(Object.assign({}, rest), {
      titlePrefix: titlePrefix,
      setTitlePrefix: setTitlePrefix
    }),
    children: children
  });
}

exports.PageHeadProvider = PageHeadProvider;

function usePageHeadPrefix(prefix) {
  var _ref = react_1["default"].useContext(exports.PageHeadContext) || {},
      setTitlePrefix = _ref.setTitlePrefix;

  react_1["default"].useEffect(function () {
    if (setTitlePrefix) {
      setTitlePrefix(prefix);
    }
  }, [prefix]);
}

exports.usePageHeadPrefix = usePageHeadPrefix;

function PageHead(_ref2) {
  var _title = _ref2.title,
      children = _ref2.children;

  var _ref3 = react_1["default"].useContext(exports.PageHeadContext) || {},
      titleSuffix = _ref3.titleSuffix,
      titlePrefix = _ref3.titlePrefix;

  var titleSegments = _title.split(' - ');

  if (titleSuffix && !titleSegments.includes(titleSuffix)) titleSegments.push(titleSuffix);
  var title = "".concat(titlePrefix ? "[".concat(titlePrefix, "] ") : '').concat(titleSegments.join(' - '));
  return react_1["default"].createElement(react_helmet_1.Helmet, null, react_1["default"].createElement("title", null, title), react_1["default"].createElement("meta", {
    name: 'og:title',
    content: title
  }), react_1["default"].createElement("meta", {
    name: 'og:title',
    content: title
  }), children);
}

exports.PageHead = PageHead;